import React from 'react';

import { KnowledgePageProps, KnowledgeProps } from '../props';

import s from '../styles/KnowledgeTab.module.css';
import { URL } from '@Pages/url';
import LazyableImage from '@Components/lazyable_image/view';

export const Knowledge = (props: KnowledgePageProps) => {
    return (
        <div className={s.tab_contents}>
            <div className={s.title}>
                <h2>ゴルフ会員権の基礎知識</h2>
            </div>
            <div className={s.main_content}>
                {/* <div className={s.link_box}>
                    <h3>知っておきたい基礎知識</h3>
                    <ul>
                        <li>メンバーになるメリット</li>
                        <li>ゴルフ会員権の種類</li>
                        <li>ゴルフ会員権の相場</li>
                        <li>ゴルフ会員権の売買</li>
                        <li>入会条件</li>
                        <li>ゴルフ会員権デビュー</li>
                    </ul>
                </div> */}
                <div className={s.link_card_box}>
                    {props.cards.map((c, i) => (
                        <LinkCard key={i} {...c} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const LinkCard = (props: KnowledgeProps) => {
    return (
        <a className={s.link_card} href={`${URL.KNOWLEDGE}/${props.id}`}>
            <div className={s.image}>
                <LazyableImage src={props.image} alt={props.title} width={200} height={145} />
            </div>
            <div className={s.info}>
                <h4>{props.title}</h4>
                <p>{props.description}</p>
            </div>
        </a>
    );
};

export default Knowledge;
